/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Link } from 'react-router';
import UINav from './Nav';
import { Container, Heading, SvgIcon } from 'seduo-ui';
import { path } from '../basename';
const UIHeader = () => {
    const navItems = [
        {
            name: 'Components',
            to: 'components/',
            icon: 'People',
        },
        {
            name: 'Typography',
            to: 'typography/',
            icon: 'Settings',
        },
        {
            name: 'Utilities',
            to: 'utilities/',
            icon: 'Pencil',
        },
        {
            name: 'Compositions',
            to: 'compositions/',
            icon: 'Power',
        },
    ];
    return (<header className="header">
            <Container className="header__container">
                <UINav navItems={navItems}/>
            </Container>
            <div id="header-menu" className="header__menu shadow collapse">
                <hr className="d-md-none mt-0"/>
                <ul className="categories list-unstyled mx-auto mb-0">
                    {navItems.map(({ name, to, icon }, index) => (<li key={`category_${index}`} className="categories__item">
                            <Link className="categories__link" to={path(to)}>
                                <SvgIcon kind={icon} className="categories__icon mr-6 mr-md-0 mb-md-5"/>
                                <span>{name}</span>
                            </Link>
                        </li>))}
                </ul>
                <hr className="d-md-none"/>
                <ul className="header__menu-list">
                    <li className="header__menu-item">
                        <Heading level={6} className="header__menu-header">
                            <strong>Header menu</strong>
                        </Heading>
                    </li>
                    <li className="header__menu-item">
                        <a className="header__menu-link text-nowrap" href="https://www.seduo.cz">
                            Seduo.cz
                        </a>
                    </li>
                    <li className="header__menu-item">
                        <a className="header__menu-link text-nowrap" href="https://github.com/lmc-eu/seduo-ui">
                            Github
                        </a>
                    </li>
                </ul>
            </div>
        </header>);
};
export default UIHeader;
